import * as firebase from "firebase";
import 'firebase/auth'
import 'firebase/database'


const firebaseConfig = {
  apiKey: "AIzaSyA0OYUpv_9CVJGj7kLwILC0h2KUPlOoVv8",
  authDomain: "aidcingenieros-8e55e.firebaseapp.com",
  databaseURL: "https://aidcingenieros-8e55e.firebaseio.com",
  projectId: "aidcingenieros-8e55e",
  storageBucket: "aidcingenieros-8e55e.appspot.com",
  messagingSenderId: "1036322451811",
  appId: "1:1036322451811:web:a9470b657d239d7c7ca356",
};

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const storage = firebase.storage();
const db = firebase.database();

export {
  auth,
  storage,
  db,
}